import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";

const AddButton = (props) => {

  return (
    <Button className={`form-save-button ${props.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      {...props}>
      <div className="flex items-center justify-center">
        <div className="flex items-center">
          <PlusOutlined />
        </div>
        <div className="px-2 text-regular flex items-center">{props?.text ? props?.text : "Add"}</div>
      </div>
    </Button>
  );
};

export default AddButton;
